import {t} from "react-i18nify";
import React from "react";



function GetTradeinEstimate (props) {
    return (
        <div className="calculator-popup-table-finance-lease__tradein-details-form-link" data-theme-style="btnRegularPrimary">
            <a className="vehicle-cash-purchase-tradeinEstimate__value-link" href="#tradein-widget" data-close="">
                {t('getTradeinEstimated')}
            </a>
        </div>
    )
}


function scrollToTradeInWidget(){
    var yOffset = document.querySelector("[data-sticky-container] .catalog-detail-sticky").offsetHeight;
    window.scrollTo({top:document.getElementById("tradein-widget").getBoundingClientRect().top + window.pageYOffset - yOffset - 10, behavior: 'smooth'});
}

function onTradeInClick() {
    const isAuthenticated = window.CommonsGeneral.AccountService.isAuthenticated();
    if (!isAuthenticated) {
        const tradeStandaloneElements = document.querySelectorAll(".reveal-overlay");

        if (tradeStandaloneElements) {
            tradeStandaloneElements.forEach(element => {
                if (element.style.display === 'block') {
                    const elementChild = element.querySelector("[data-reveal]");

                    document.body.classList.remove('is-reveal-open');
                    element.style.display = 'none';
                    if (elementChild) elementChild.style.display = 'none';

                }
            })
        }

        window.Login.widgets.Login.services.LoginLightService.openSignupModal({
            onClose: () => {
                if (window.Login.widgets.Login.services.LoginLightService.isAuthenticated()) {
                    window.location.href = t('getTradeinEstimatedLink');
                }
                return true;
            },
        });
    } else {
        window.location.href = t('getTradeinEstimatedLink');
    }
}
export default GetTradeinEstimate